import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Calendar,
  car,
  kilometers,
  location,
  moneyWhite,
  star,
  carIcon,
  chatRound,
  confirmIcon,
} from '../../assets/icons';
import {
  ChooseMediator,
  CompleteOrder,
  ConfirmRequest,
  MConfirmation,
  MediatorRate,
  PaidRequest,
} from '../index';

import {
  defaultLettersCircle,
  languageAr,
  toastConfig,
  userRole,
} from '../../helpers/helper';
import CarColor from './CarColor';
import {
  getConfirmationRequest,
  paidConfirmationRequest,
  rateMediator,
  updateConfirmationRequest,
} from '../../services/apis/order';
import { CompleteOfferContext } from '../../context/CompleteOfferContext';
import { confirmationOffer } from '../../services/apis/offer';
import { getUserInfo } from '../../services/apis/user';
import { toast } from 'react-toastify';

const CardOfferDetails = ({
  carOffer,
  mediator,
  commision,
  from,
  offer,
  finalOffer,
  goProfile,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const completeOfferContext = useContext(CompleteOfferContext);
  const [openModalCars, setOpenModalCars] = useState(false);
  const [confirmation, setConfirmation] = useState(null);

  useEffect(() => {
    if (finalOffer) {
      getConfirmationRequestData();
    }
  }, []);

  const confirm = () => {
    setOpenCompleteOfferModal(false);
    setOpenChooseCarModal(true);
  };

  const completeRequestConfirm = () => {
    confirmRequestOffer();
  };

  const goToHome = () => {
    navigate('/');
  };

  const handleUserInfo = async () => {
    const response = await getUserInfo();

    userRole == 3
      ? setUserInfo(
          response
        )
      : setUserInfo(response);
  };

  useEffect(() => {
    handleUserInfo();
  }, []);

  const getConfirmationRequestData = async () => {
    const response = await getConfirmationRequest('', finalOffer);
    response.data.medInfo = response.data.otherUserInfo;
    response.data.medInfo.avgRating = response.data.otherUserInfo.medAvgRating;
    response.data.cars = [];
    response.data.confirmationCars.forEach((car) => {
      response.data.cars.push(car.offerCar);
    });
    setConfirmation(response.data);
  };

  const [valueConfirm, setValueConfirm] = useState('');
  const [valueComment, setValueComment] = useState('');

  const [valueCommentRate, setValueCommentRate] = useState('');
  const [valueStarRate, setValueStarRate] = useState('');
  const [valueRate, setValueRate] = useState('');
  const [showMessageSuccess, setShowMessageSuccess] = useState(false);
  const [openConfirmRequestModal, setOpenConfirmRequestModal] = useState(false);
  const [openPaidRequestModal, setOpenPaidRequestModal] = useState(false);
  const [confirmationId, setConfirmationId] = useState(null);
  const [hideActionModal, setHideActionModal] = useState(false);
  const [openRateMediatorModal, setOpenRateMediatorModal] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openCompleteOfferModal, setOpenCompleteOfferModal] = useState(false);
  const [openChooseCarModal, setOpenChooseCarModal] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [offers, setOffers] = useState([]);
  const [loadingOffers, setLoadingOffers] = useState(false);
  const [showImage, setShowImage] = useState(null);

  const handleValueConfirm = (value) => {
    setValueConfirm(value);
  };
  const handleValueComment = (value) => {
    setValueComment(value);
  };

  const handleValueCommentRate = (value) => {
    setValueCommentRate(value);
  };
  const handleValueStarRate = (value) => {
    setValueStarRate(value);
  };
  const handleValueRate = (value) => {
    setValueRate(value);
  };
  const showMessageSuccessRateMediator = (value) => {
    setShowMessageSuccess(value);
  };

  const action = (offer) => {
    setConfirmationId(offer.id);
    if (offer.status == 3) {
      if (userInfo.userId == offer.userId) {
        setOpenConfirmRequestModal(
          true,
          setHideActionModal(true, getConfirmationRequestData(offer.id))
        );
      } else {
        setOpenConfirmRequestModal(
          true,
          setHideActionModal(false, getConfirmationRequestData(offer.id))
        );
      }
    } else if (offer.status == 1 || offer.status == 4) {
      if (userRole == 2) {
        setOpenPaidRequestModal(true, getConfirmationRequestData(offer.id));
      } else {
        setOpenConfirmRequestModal(
          true,
          setHideActionModal(true, getConfirmationRequestData(offer.id))
        );
      }
    } else if (offer.status == 5) {
      setOpenConfirmRequestModal(
        true,
        setHideActionModal(true, getConfirmationRequestData(offer.id))
      );
    }
  };

  const confirmRequest = async () => {
    if (valueConfirm == 2 && !valueComment) {
      toast.error(t('completeRequest.requiredComment'), toastConfig);
    } else {
      let data = {
        confirmationStatus: valueConfirm,
        rejectComment: valueComment,
      };
      try {
        const response = await updateConfirmationRequest(data, confirmationId);
        setOpenConfirmRequestModal(false);
        toast.success(
          t('completeRequest.messageSuccessConfirmed'),
          toastConfig
        );
      } catch (error) {
        if (error.response) {
          if (error.response.status == 400) {
            toast.error(error.response.data.message, toastConfig);
          } else if (error.response.status == 500) {
            toast.error(error.response.data.message, toastConfig);
          } else if (error.response.status == 401) {
            toast.error(error.response.data.message, toastConfig);
          }
        }
      }
    }
  };

  const confirmRequestOffer = async () => {
    setLoading(true);
    let cars = [];
    completeOfferContext.selectedCars.forEach((carId) => {
      cars.push({ offerCarId: carId });
    });
    let data = {
      cars: cars,
    };
    try {
      const response = await confirmationOffer(data);
      setOpenChooseCarModal(false);
      setOpenConfirmModal(true);
      toast.success(t('تم تاكيد الطلب بنجاح'), toastConfig, setLoading(false));
    } catch (error) {
      if (error.response) {
        if (error.response.status == 400) {
          toast.error(
            error.response.data.message,
            toastConfig,
            setLoading(false)
          );
        } else if (error.response.status == 500) {
          toast.error(
            error.response.data.message,
            toastConfig,
            setLoading(false)
          );
        } else {
          toast.error(
            error.response.data.message,
            toastConfig,
            setLoading(false)
          );
        }
      }
    }
  };

  const paidRequest = () => {
    if (confirmation.totalCommission == 0) {
      setOpenRateMediatorModal(true);
    } else {
      paidRequestAction();
    }
  };

  const paidRequestAction = async () => {
    let data = {
      params: {
        confirmationId: confirmationId,
      },
    };
    try {
      const response = await paidConfirmationRequest(data, confirmationId);
      toast.success(t('paidRequest.paySuccess'), toastConfig);
      setOpenPaidRequestModal(false);
      setOpenRateMediatorModal(true);
    } catch (error) {
      if (error.response) {
        if (error.response.status == 400) {
          toast.error(error.response.data.message, toastConfig);
        } else if (error.response.status == 500) {
          toast.error(error.response.data.message, toastConfig);
        }
      }
    }
  };

  const ratedMediator = async () => {
    let data = {
      mediatorId: confirmation.medInfo.id,
      offerId: confirmation.offerRes.id,
      comment:
        valueRate == 1
          ? t('paidRequest.acceptable')
          : valueRate == 2
            ? t('paidRequest.good')
            : valueRate == 3
              ? t('paidRequest.veryGood')
              : t('paidRequest.excellent') + '  : ' + valueCommentRate,
      rating: valueStarRate,
    };
    try {
      const response = await rateMediator(data);
      toast.success(t('paidRequest.ratingSuccess'), toastConfig);
      setShowMessageSuccess(true);
    } catch (error) {
      if (error.response) {
        if (error.response.status == 400) {
          toast.error(error.response.data.message, toastConfig);
        } else if (error.response.status == 500) {
          toast.error(error.response.data.message, toastConfig);
        }
      }
    }
  };

  const validImages = carOffer?.filesUrl?.filter((item) =>
    /\.(jpg|jpeg|png)$/i.test(item)
  );

  const validFiles = carOffer?.filesUrl?.filter((item) =>
    /\.(pdf|doc|docx|xlsx|xls)$/i.test(item)
  );

  const showMessage = (status) => {
    if (status == 5) {
      return t('orderDetails.offerCompleteMessage');
    }
    if (status == 3) {
      return t('orderDetails.offerPendingMessage');
    }
    if (status == 2) {
      return t('orderDetails.offerRejectedMessage');
    }
    if (status == 1) {
      return t('orderDetails.offerAcceptedMessage');
    }
    if (status == 4) {
      return t('orderDetails.offerUnderPaymentMessage');
    }
  };

  return (
    <div
      className="w-[100%] bg-[#D7E2FF] rounded-[20px] mr-auto ml-auto"
      style={{ direction: languageAr ? 'rtl' : 'ltr' }}
    >
      <div className="flex flex-row justify-between">
        <div
          className="flex flex-row items-center p-2 m-[10px] rounded-[28px] bg-[#00CEBC] cursor-pointer"
          onClick={goProfile}
        >
          <div className="rounded-full p-1 bg-[#73D3CB]">
            {mediator?.profileImg == null ? (
              defaultLettersCircle(mediator?.fullName)
            ) : (
              <img
                className="w-[36px] h-[36px] rounded-full"
                src={mediator?.profileImg}
              />
            )}
          </div>
          <div className="flex flex-col mx-3">
            <div className="flex flex-row items-center text-[#ffffff] text-[15px] font-700">
              <div>{t('listOffers.mediator')}</div>
              <div className="px-2">:</div>
              <div>{mediator?.fullName} </div>
            </div>
            <div className="flex flex-row items-center">
              <div>
                <img src={star} />
              </div>
              <div className="text-[#ffffff] text-[15px] font-700">
                {mediator?.avgRating}
              </div>
            </div>
          </div>
        </div>
        {from == 'owner' ? (
          <>
            {offer.statusId == 3 ? (
              <div className="bg-[#00CEBC] rounded-[12px] shadow-lg flex flex-row justify-center items-center p-1">
                <img src={chatRound} />
                <div className="text-[13px] font-400 text-white mx-3">
                  {t('statusActions.conversation')}
                </div>
              </div>
            ) : null}
          </>
        ) : (
          <>
            {!carOffer?.brand ? null : (
              <div
                className={`bg-[#3E0292] flex flex-row items-center ${languageAr ? 'rounded-tl-[20px] rounded-tr-[0px] rounded-bl-[0px] rounded-br-[20px]' : 'rounded-tl-[0px] rounded-tr-[20px] rounded-bl-[20px] rounded-br-[0px]'} text-[14px] text-[#ffffff] p-3`}
              >
                <div>
                  {languageAr
                    ? carOffer?.brand?.nameAr
                    : carOffer?.brand?.nameEn}
                </div>
              </div>
            )}
          </>
        )}
      </div>
      <div className="grid grid-cols-[40%_60%] max800:grid-cols-1 p-5">
        <div className="flex flex-col p-2">
          {!carOffer.brand ? null : (
            <div className="flex flex-row items-center">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.cars')}:
              </div>
              <div className="grid lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 max600:grid-cols-1 gap-x-2 mx-2">
                <div className="bg-[#ffffff] rounded-[12px] p-2 flex flex-row items-center">
                  <div>
                    <img
                      src={carOffer.brand.image}
                      className="w-[20px] h-[20px]"
                    />
                  </div>
                  <div className="text-[#0000000] text-[12px] font-400 px-2">
                    {languageAr
                      ? carOffer?.brand?.nameAr
                      : carOffer?.brand?.nameEn}
                  </div>
                </div>
              </div>
            </div>
          )}
          {!carOffer.model ? null : (
            <div className="flex flex-row items-center mt-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.category')}:
              </div>
              <div className="grid lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 max600:grid-cols-1 gap-x-2 mx-2">
                <div className="bg-[#ffffff] rounded-[12px] p-2 flex flex-row items-center">
                  <div>
                    <img src={carIcon} className="w-[20px] h-[20px]" />
                  </div>
                  <div className="text-[#0000000] text-[12px] font-400 px-2">
                    {languageAr
                      ? carOffer?.model?.nameAr
                      : carOffer?.model?.nameEn}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!carOffer?.city ? null : (
            <div className="flex flex-row items-center mt-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.city')}:
              </div>
              <div className="grid lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 max600:grid-cols-1 gap-x-2 mx-2">
                <div className="bg-[#ffffff] rounded-[12px] p-2 flex flex-row items-center">
                  <div>
                    <img src={location} className="w-[20px] h-[20px]" />
                  </div>
                  <div className="text-[#0000000] text-[12px] font-400 px-2">
                    {languageAr
                      ? carOffer?.city?.nameAr
                      : carOffer?.city?.nameEn}
                  </div>
                </div>
              </div>
            </div>
          )}
          {!carOffer.odo ? null : (
            <div className="flex flex-row items-center my-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.km')}:
              </div>
              <div className="flex flex-row bg-[#E6EDFF] rounded-[12px] p-2 mx-2">
                <div>
                  <img src={kilometers} className="w-[20px] h-[20px]" />
                </div>
                <div className="flex flex-row items-center px-2">
                  <div className="text-[#BBBBBB] text-[10px] font-400">
                    {t('listOrders.from')}
                  </div>
                  <div className="text-[#000000] text-[13px] font-400 px-2">
                    {carOffer.odo}
                  </div>
                  <div className="text-[#BBBBBB] text-[10px] font-400">
                    {t('listOrders.km')}
                  </div>
                </div>
              </div>
            </div>
          )}

          {!carOffer?.color ? null : (
            <div className="flex flex-row items-center">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('offerDetails.color')}:
              </div>
              <div className="grid lg:grid-cols-2 2xl:grid-cols-2 xl:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 max600:grid-cols-1 gap-x-2 mx-2">
                <div className="bg-[#ffffff] rounded-[12px] p-2 flex flex-row items-center">
                  <div>
                    <CarColor
                      color={
                        carOffer?.color?.hexCode == '#FFFFFF'
                          ? '#808080'
                          : carOffer?.color?.hexCode
                      }
                    />{' '}
                  </div>
                  <div
                    style={{
                      color:
                        carOffer?.color?.hexCode == '#FFFFFF'
                          ? '#808080'
                          : carOffer?.color?.hexCode,
                    }}
                    className="text-[12px] font-400 px-2"
                  >
                    {languageAr
                      ? carOffer?.color?.nameAr
                      : carOffer?.color?.nameEn}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="flex flex-row items-center my-3">
            <div className="text-[#3E0292] text-[14px] font-500">
              {t('offerDetails.price')}:
            </div>
            <div className="flex flex-row bg-[#00CEBC] rounded-[12px] p-2 mx-2">
              <div>
                <img src={moneyWhite} className="w-[20px] h-[20px]" />
              </div>
              <div className="flex flex-row items-center px-2">
                <div className="text-[12px] font-500 text-[#ffffff]">
                  {t('listOrders.price')}
                </div>
                <div className="text-[12px] font-500 text-[#ffffff] px-2">
                  :
                </div>
                <div className="text-[12px] font-500 text-[#ffffff] px-2">
                  {carOffer?.price}
                </div>
                <div className="text-[12px] font-500 text-[#ffffff]">
                  {t('listOrders.Rial')}
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-row items-center">
            <div className="text-[#3E0292] text-[14px] font-500">
              {t('offerDetails.commission')}:
            </div>
            <div className="flex flex-row bg-[#04C500CC] rounded-[12px] p-2 mx-2">
              <div>
                <img src={moneyWhite} className="w-[20px] h-[20px]" />
              </div>
              <div className="flex flex-row items-center px-2">
                <div className="text-[12px] font-500 text-[#ffffff] px-2">
                  {commision ? commision : carOffer?.commission}
                </div>
                {!/%/.test(carOffer?.commission) && (
                  <div className="text-[12px] font-500 text-[#ffffff]">
                    {t('listOrders.Rial')}
                  </div>
                )}
              </div>
            </div>
          </div>
          {!confirmation?.invoiceUrl ? null : (
            <div className="flex flex-row items-center my-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('listOrders.invoice')}:
              </div>
              <div className="flex flex-row bg-[#3E0292] rounded-[12px] p-2 mx-2">
                <div>
                  <img src={moneyWhite} className="w-[20px] h-[20px]" />
                </div>
                <div
                  className="text-[12px] font-500 text-[#ffffff] px-2"
                  onClick={() =>
                    (window.location.href = confirmation?.invoiceUrl)
                  }
                >
                  {t('offerDetails.downloadInvoice')}
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          className={`flex flex-col border max800:border-0 ${languageAr ? 'border-r-[#ffffff]' : 'border-l-[#ffffff]'} p-3`}
        >
          <div className="flex flex-row items-center">
            <div className="text-[#3E0292] text-[14px] font-500">
              {' '}
              {t('offerDetails.year')}:
            </div>
            <div className="flex flex-row bg-[#ffffff] rounded-[12px] p-2 mx-2">
              <div>
                <img src={Calendar} className="w-[20px] h-[20px]" />
              </div>
              <div className="flex flex-row items-center px-2">
                <div className="text-[#000000] text-[13px] font-[600px] px-2">
                  {carOffer?.modelYear}
                </div>
              </div>
            </div>
          </div>
          {!confirmation ? null : (
            <div>
              <div
                onClick={() => {
                  confirmation.status == 2 ? '' : action(confirmation);
                }}
                className="grid lg:grid-cols-1 2xl:grid-cols-1 xl:grid-cols-1 md:grid-cols-1 sm:grid-cols-1 max600:grid-cols-1 gap-x-2 gap-y-2 m-3 cursor-pointer"
              >
                <div className="text-[#3E0292] text-[14px] font-500">
                  {t('offerDetails.number')}:{confirmation.id}
                </div>
                <div className="bg-[#ffffff] rounded-[12px] p-2 flex flex-row items-center mt-1">
                  <div>
                    <img src={car} className="w-[20px] h-[20px]" />
                  </div>
                  <div className="text-[#0000000] text-[12px] font-400 px-2">
                    {showMessage(confirmation.status)}
                  </div>
                </div>
              </div>
            </div>
          )}
          {carOffer.description == '' ? null : (
            <div className="flex flex-row items-center mt-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {' '}
                {t('offerDetails.description')}:
              </div>
              <div className="flex flex-row bg-[#ffffff] rounded-[12px] p-2 mx-2">
                <div className="text-[#303030] text-[14px] font-400">
                  {carOffer.description}
                </div>
              </div>
            </div>
          )}

          {offer.statusMessage == null ? null : (
            <div className="flex flex-row items-center mt-3">
              <div className="text-[#3E0292] text-[14px] font-500">
                {' '}
                {t('offerDetails.descriptionCauseReject')}:
              </div>
              <div className="flex flex-row bg-[#ffffff] rounded-[12px] p-2 mx-2">
                <div className="text-[#303030] text-[14px] font-400">
                  {offer.statusMessage}
                </div>
              </div>
            </div>
          )}

          <div className="flex flex-row items-center mt-3">
            <div className="text-[#3E0292] text-[14px] font-500">
              {' '}
              {t('offerDetails.order')}:
            </div>
            <div
              className="flex flex-row bg-[#ffffff] rounded-[12px] p-2 mx-2"
              onClick={() => navigate(`/orders/${offer?.requestId}`)}
            >
              <div className="text-[#303030] text-[14px] font-400">
                {offer?.requestId}
              </div>
            </div>
          </div>

          {validImages?.length == 0 ? null : (
            <div className="flex flex-col my-3 cursor-pointer">
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('orderDetails.images')}:
              </div>
              <div className="bg-[#ffffff] rounded-[12px] p-2 mx-2">
                <div className="grid xl:grid-cols-3 2xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 max600:grid-cols-1 sm:grid-cols-2 gap-2">
                  {validImages.map((image, index) => (
                    <div
                      key={index}
                      onClick={() =>
                        setOpenModalCars(true, setShowImage(image))
                      }
                    >
                      <img
                        src={image}
                        className="h-[100px] w-[100%] rounded-[5px] border-[0.5px] border-[#999999]"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {validFiles?.length == 0 ? null : (
            <div
              className="flex flex-col my-3 cursor-pointer"
            >
              <div className="text-[#3E0292] text-[14px] font-500">
                {t('orderDetails.files')}:
              </div>
              <div className="bg-[#ffffff] rounded-[12px] p-2 mx-2">
                <div className="grid xl:grid-cols-3 2xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 max600:grid-cols-1 sm:grid-cols-2 gap-2">
                  {validFiles?.map((file, index) => (
                    <div key={index}>
                      <div
                        className="text-[#3E0292] text-[13px] font-500 underline"
                        onClick={() => (window.location.href = file)}
                      >
                        {t('myOrders.file') + ' ' + index + 1}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <MConfirmation
        openModal={openModalCars}
        setOpenModal={setOpenModalCars}
        title={t('orderDetails.images')}
        content={
          <div
            className="h-56 sm:h-64 xl:h-80 2xl:h-96 carousel-container"
            style={{ direction: 'ltr' }}
          >
            <div style={{ direction: languageAr ? 'rtl' : 'ltr' }}>
              <img
                src={showImage}
                className="h-56 sm:h-64 xl:h-80 2xl:h-96 w-[100%]"
                alt={`image`}
              />
            </div>
          </div>
        }
      />
      <MConfirmation
        loading={loading}
        openModal={openConfirmRequestModal}
        showFooter={hideActionModal ? false : true}
        setOpenModal={setOpenConfirmRequestModal}
        title={t('completeRequest.completeRequest')}
        content={
          <ConfirmRequest
            hideActionModal={hideActionModal}
            onValueChangeComment={handleValueComment}
            onValueChange={handleValueConfirm}
            offer={confirmation}
            from="carowner"
          />
        }
        confirm={confirmRequest}
      />
      <MConfirmation
        loading={loading}
        openModal={openPaidRequestModal}
        setOpenModal={setOpenPaidRequestModal}
        showFooter={true}
        titleButton={
          confirmation?.totalCommission > 0
            ? t('paidRequest.payment')
            : t('paidRequest.rating')
        }
        singleButton={true}
        content={
          <PaidRequest
            onValueChange={handleValueConfirm}
            offer={confirmation}
            from="carowner"
          />
        }
        confirm={paidRequest}
      />
      <MConfirmation
        loading={loading}
        openModal={openRateMediatorModal}
        showFooter={true}
        setOpenModal={setOpenRateMediatorModal}
        title={t('paidRequest.ratingMediator')}
        content={
          <MediatorRate
            onValueChangeCommentRate={handleValueCommentRate}
            onValueChangeStarRate={handleValueStarRate}
            onValueChangeRate={handleValueRate}
            showMessageSuccess={showMessageSuccess}
            setShowMessageSuccess={showMessageSuccessRateMediator}
            from="carowner"
          />
        }
        titleButton={t('paidRequest.rating')}
        singleButton={true}
        confirm={ratedMediator}
      />
      <MConfirmation
        loading={loading}
        openModal={openCompleteOfferModal}
        showFooter={true}
        setOpenModal={setOpenCompleteOfferModal}
        title={t('completeRequest.chooseMediator')}
        content={
          <ChooseMediator
            offers={offers}
            from="carowner"
            loadingOffers={loadingOffers}
          />
        }
        confirm={confirm}
        disabled={offers.length > 0 ? false : true}
      />
      <MConfirmation
        loading={loading}
        openModal={openChooseCarModal}
        showFooter={true}
        setOpenModal={setOpenChooseCarModal}
        title={t('completeRequest.completeRequest')}
        content={<CompleteOrder offer={completeOfferContext.offer} />}
        confirm={completeRequestConfirm}
      />
      <MConfirmation
        loading={loading}
        openModal={openConfirmModal}
        showFooter={true}
        setOpenModal={setOpenConfirmModal}
        title={t('completeRequest.successSentToMediator')}
        content={
          <div className="flex justify-center items-center">
            <img src={confirmIcon} />
          </div>
        }
        titleButton={t('completeRequest.backToHome')}
        singleButton={true}
        confirm={goToHome}
      />
    </div>
  );
};

export default CardOfferDetails;
